import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { SearchableSelectOption } from "@/components/ui/SearchableSelect";
import {
  DEFAULT_SALES_ORDER_COUNTRY_CODE,
  SALES_ORDER_COUNTRY_OPTIONS,
} from "@integrator-src/sales-order/sales-order-address-country";

type HubCountriesResponse = {
  countries: Array<{ code: string; name: string; upsCountryCode: string }>;
};

const STATIC_COUNTRY_SELECT_OPTIONS: SearchableSelectOption[] = SALES_ORDER_COUNTRY_OPTIONS.map((option) => ({
  value: option.value,
  label: option.label,
}));

async function fetchHubCountrySelectOptions(): Promise<SearchableSelectOption[]> {
  const data = await apiFetch<HubCountriesResponse>("/api/reference/countries");
  if (!data.countries?.length) {
    return STATIC_COUNTRY_SELECT_OPTIONS;
  }
  return data.countries.map((country: HubCountriesResponse["countries"][number]) => ({
    value: country.code,
    label: country.name,
    description: country.code === DEFAULT_SALES_ORDER_COUNTRY_CODE ? undefined : country.code,
  }));
}

export function useHubCountrySelectOptions(): SearchableSelectOption[] {
  const query = useQuery({
    queryKey: ["reference", "countries"],
    queryFn: fetchHubCountrySelectOptions,
    staleTime: 60 * 60 * 1000,
    placeholderData: STATIC_COUNTRY_SELECT_OPTIONS,
  });
  return query.data ?? STATIC_COUNTRY_SELECT_OPTIONS;
}
